export default {"src":"/_next/static/media/arrow-left.0a3dff10.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};